export default __webpack_public_path__ + "img/86d0faeb929a9b01af73eb3568eed52b.png";